import * as React from "react";
const SvgOnlyIncentive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2m-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m-5 1c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1M4 19v-2h16v2zM4 8v6h16V8h-5.08L17 10.83 15.38 12 13 8.76 12 7.4l-1 1.36L8.62 12 7 10.83 9.08 8z"
      clipRule="evenodd"
    />
    <mask
      id="only_incentive_svg__a"
      width={20}
      height={19}
      x={2}
      y={2}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path
        fillRule="evenodd"
        d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2m-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m-5 1c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1M4 19v-2h16v2zM4 8v6h16V8h-5.08L17 10.83 15.38 12 13 8.76 12 7.4l-1 1.36L8.62 12 7 10.83 9.08 8z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#only_incentive_svg__a)">
      <path d="M0 0h24v24H0z" />
    </g>
  </svg>
);
export default SvgOnlyIncentive;
